import { useState } from "react";
import "./UserAuth.css";
import { api } from '../config/api';
export default function UserLogin({
  setToken,
  onLoginSuccess,
  onRegisterClick,
}) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    console.log("🔹 handleLogin() function triggered!");
    const response = await fetch(api.login, {
    // const response = await fetch('http://127.0.0.1:5000/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });
    const data = await response.json();

    if (response.ok) {
      setToken(data.access_token); // Store token in app or localStorage
      localStorage.setItem('token', data.access_token); 
      localStorage.setItem('userAuthenticated', 'true');
      setError("");
      onLoginSuccess(data.access_token);
    } else {
      setError(data.message || "Login failed");
    }
  };

  return (
    <form onSubmit={handleLogin} className="mainContainer">
      <div className="titleContainer">
        <h4>Login</h4>
      </div>
      <div className="inputContainer">
        <input
          type="text"
          value={username}
          placeholder="Enter your username"
          onChange={(e) => setUsername(e.target.value)} // Fixed to use setUsername
          className="inputBox"
          required
        />
      </div>
      <br />
      <div className="inputContainer">
        <input
          type="password"
          value={password}
          placeholder="Enter your password"
          onChange={(e) => setPassword(e.target.value)}
          className="inputBox"
          required
        />
      </div>
      <br />
      <div className="inputContainer">
        <button type="submit" className="inputLogin">
          Log in
        </button>
        <button
          type="button"
          className="inputRegister"
          onClick={onRegisterClick}
        >
          Register
        </button>
      </div>
      {error && <p className="errorLabel">{error}</p>}
    </form>
  );
}
